import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@entities/User';
import { EmailVerifyBanner } from '@features/EmailVerify';
import { ProfileForm, ProfileHeader } from '@features/Profile';
import { SubscriptionCard } from '@features/Subscription';

export default function ProfilePage() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  return (
    <div className="mx-auto max-w-[900px] animate-fadeIn px-4 pb-28 pt-16 sm:px-6 nav:px-12 nav:pb-20 nav:pt-10">
      <header className="mb-9">
        <h1 className="text-balance pb-1.5 font-serif text-[30px] font-medium leading-[1.2] tracking-[-0.02em] sm:text-[36px] nav:text-[44px]">
          {t('profile.title')}
        </h1>
        <div className="mt-2.5 text-[14px] tracking-[0.02em] text-muted">{t('profile.sub')}</div>
      </header>
      {user && !user.emailVerified && <EmailVerifyBanner email={user.email} variant="compact" />}
      <ProfileHeader />
      <SubscriptionCard />
      <ProfileForm />
    </div>
  );
}
